import { SxProps } from '@mui/material'

interface DotStyles {
  dotWrapper: SxProps
  light: SxProps
}

export const dotStyles: DotStyles = {
  dotWrapper: {
    width: '5px',
    height: '5px',
    borderRadius: '50%',
    backgroundColor: 'utils.gray500',
    borderColor: 'utils.gray500',
    display: 'inline-block',
    alignSelf: 'center',
  },
  light: {
    backgroundColor: 'background.default',
  },
}
